<template>
  <p>Oops! No Page Found ไม่เจอหน้าที่คุณร้องขอ</p>
</template>
<script>
  // Extensions
  import View from '@/views/View'

  export default {
    name: 'FourOhFour',

    metaInfo: { title: 'Oops! No Page Found' },

    extends: View,


    props: {
      id: {
        type: String,
        default: 'about',
      },
    },
  }
</script>
